import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function DataDisplay({ children }) {
    return _jsx("div", { children: children });
}
function DisplayRow({ children, label, className = "" }) {
    return (_jsxs("div", { className: `wpqt-mb-1 ${className}`, children: [_jsx("span", { className: "wpqt-font-semibold", children: label }), _jsx("span", { className: "wpqt-text-base", children: children })] }));
}
export { DataDisplay, DisplayRow };
